module.exports = __webpack_public_path__ + "static/media/haroldstenurecelebration.9fa12e8a.jpeg";